export default {
  related: 'Related articles',
}
